/* global $ toastr */

import React, { Component } from 'react'
import { request, format_date } from '../../lib/utils'
import AttrInput from '../../lib/attr_input'
import { store } from '../../../index'



export class DeputyModal extends Component {

  constructor(props) {
    super(props);

    this.renderModalBody = this.renderModalBody.bind(this);
    this.renderAddForm = this.renderAddForm.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.switchDeputy = this.switchDeputy.bind(this);

    this.requestLock = false;

    this.state = {
      deputy_data: undefined,
      show_form_add: false,
      add_form: {},
    }
  }

  // Форма добавления записи о замещении
  renderAddForm() {
    const InputChange = (name, value) => {
      const add_form = { ...this.state.add_form, [name]: value }
      this.setState({ add_form: add_form })
    }

    const add = () => {
      request({
        method: 'put',
        url: `/api/auth/deputy`,
        data: this.state.add_form,
        success: (data) => {
          this.setState({show_form_add: false, deputy_data: [...this.state.deputy_data, data]})
        },
      })
    }

    const add_form = this.state.add_form
    return <div>
      <AttrInput title="Заместитель" data_type="integer" choice_name="User" name="deputy_id" access="edit" onChange={InputChange} value={add_form.deputy_id} />
      <AttrInput title="Начало действия замещения" data_type="date" name="d_start" access="edit" onChange={InputChange} value={add_form.d_start} />
      <AttrInput title="Окончание действия замещения" data_type="date" name="d_end" access="edit" onChange={InputChange} value={add_form.d_end} />
      <div className="mt-1">
        <span className="btn btn-primary p-2" onClick={add}>Добавить</span>
      </div>
    </div>
  }

  // Удалить запись о замещении
  deleteItem(deputy_id) {
    const deputy_data = this.state.deputy_data

    request({
      method: 'delete',
      url: `/api/auth/deputy?deputy_id=${deputy_id}`,
      success: (data) => {
        this.setState({
          deputy_data: deputy_data.filter(function (deputy_data) {
            return deputy_data.id !== deputy_id;
          })
        })
      },
    })
  }

  // Переключиться под оператора (применить замещение)
  switchDeputy(deputy_id) {

    request({
      method: 'post',
      url: `/api/auth/deputy?deputy_id=${deputy_id}`,
      success: (data) => {
        toastr.info("Вы переключились под другого пользователя и теперь имеете все его разрешения")

        this.setState({
          deputy_data: undefined,
          show_form_add: false,
          add_form: {},
          redirect_to: "/"
        }, () => {
          $("#modal_deputy").modal("hide")
          store.dispatch({ type: 'auth_authenticated', data })
        })
      },
    })
  }

  // Тело модалки
  renderModalBody() {
    // Инициализатор
    if (this.props.is_open && this.state.deputy_data === undefined && !this.requestLock) {
      this.requestLock = true
      request({
        method: 'get',
        url: `/api/auth/deputy`,
        success: (data) => {
          this.requestLock = false
          this.setState({ deputy_data: data })
        },
        error: () => {
          this.requestLock = false
        }
      })
    }

    if (this.state.deputy_data === undefined) {
      return <span>Загрузка данных...</span>
    }

    // Рассортируем на записи когда меня могут замещать и я могу кого-то замещать
    let deputy_owner = [], deputy_can_be = []
    this.state.deputy_data.forEach(item => {
      if (item.user_id === this.props.user.id) {
        deputy_owner.push(item)
      }
      else {
        deputy_can_be.push(item)
      }
    });

    // Таблица где меня могут замещать (я настраиваю)
    let deputy_owner_table;
    if (deputy_owner.length > 0) {
      deputy_owner_table = <table className="table">
        <thead>
          <tr>
            <th>Сотрудник</th>
            <th>С какого числа</th>
            <th>По какое число</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {deputy_owner.map(row => {
            return <tr>
              <td>{this.props.getChoice("User", row.deputy_id)}</td>
              <td>{format_date(row.d_start)}</td>
              <td>{format_date(row.d_end)}</td>
              <td>
                <span className="btn btn-icon btn-sm btn-secondary waves-effect waves-light" onClick={() => {
                  this.deleteItem(row.id)
                }}>
                  <span className="ti ti-backspace"></span>
                </span>
              </td>
            </tr>
          })}
        </tbody>
      </table>
    }

    // Таблица где я могу кого-то замещать
    let deputy_can_be_table;
    if (deputy_can_be.length > 0) {
      deputy_can_be_table = <table className="table">
        <thead>
          <tr>
            <th>Сотрудник</th>
            <th>С какого числа</th>
            <th>По какое число</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {deputy_can_be.map(row => {
            return <tr>
              <td>{this.props.getChoice("User", row.user_id)}</td>
              <td>{format_date(row.d_start)}</td>
              <td>{format_date(row.d_end)}</td>
              <td>
                <span className="btn btn-icon btn-sm btn-success waves-effect waves-light" onClick={() => {this.switchDeputy(row.id)}}>
                  <span className="ti ti-user-plus"></span>
                </span>
              </td>
            </tr>
          })}
        </tbody>
      </table>
    }

    return <div>
      <h4 className="mt-1 mb-1">Кто может замещать меня</h4>
      {deputy_owner_table ? deputy_owner_table : <div>Записи отсутствуют...</div>}
      <span className="btn btn-secondary p-2 waves-effect waves-light mt-1" onClick={() => { this.setState({ show_form_add: !this.state.show_form_add }) }}>
        Добавить
      </span>
      {this.state.show_form_add && this.renderAddForm()}

      <h4 className="mt-3 mb-1">Кого могу замещать я</h4>
      {deputy_can_be_table ? deputy_can_be_table : <div>Записи отсутствуют...</div>}
    </div>

  }

  render() {
    return (
      <div className="modal fade" id="modal_deputy" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Заместители</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {this.renderModalBody()}
            </div>
            <div className="modal-footer">
              <span className="btn btn-secondary me-1" data-bs-dismiss="modal">
                Закрыть
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
